module.exports = __webpack_public_path__ + "static/media/tesla_logo_icon.0572a78b.png";